import styled from 'styled-components';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { theme } from '_constants/theme';
import { ROUTES } from '_constants/routes';
import { hexToRGBA } from '_helpers/theme';
import { getBlogArticle, getBlogImageAlt } from '_helpers/blog';

import { useBlogSubRoute, useRandomBlogSubRoutes } from '_hooks';

import * as Layout from '_components/atomic/layouts';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  margin-bottom: ${theme.spaces.large6X}px;
  background: ${hexToRGBA(theme.colors.indigo[600], 0.05)};
`;

const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: center;

  max-width: ${theme.spaces.large24X * 10 + 80}px;
  width: 100%;

  padding-top: ${theme.spaces.large16X}px;
  padding-bottom: ${theme.spaces.large16X}px;

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.large6X}px;
    padding-bottom: ${theme.spaces.large6X}px;
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
  }
`;

const StyledContentBody = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    gap: ${theme.spaces.large4X}px;
  }
`;

const StyledArticleContainer = styled.div`
  width: 30%;

  @media ${theme.devices.tablet} {
    width: 100%;
  }
`;

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: ${theme.spaces.large}px;

  img {
    width: 100%;
  }
`;

const StyledLink = styled(Link)`
  font-family: inherit;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: inherit;
  }
`;

const BlogFooterSection = () => {
  const router = useRouter();
  const route = useBlogSubRoute(router.pathname);
  const randomBlogSubRoutes = useRandomBlogSubRoutes(route);

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <StyledContentBody>
          {randomBlogSubRoutes.map((subRoute) => {
            const { title, description, imgSrc } =
              getBlogArticle(subRoute) || {};

            const imgAlt = getBlogImageAlt(subRoute);

            return (
              <StyledArticleContainer key={subRoute}>
                <StyledImageContainer>
                  <picture>
                    <source srcSet={imgSrc} type="image/svg" />
                    <img src={imgSrc} alt={imgAlt} />
                  </picture>
                </StyledImageContainer>
                <Layout.Card.Text desktop size={theme.fontSizes.medium} boldest>
                  <StyledLink href={`${ROUTES.blog}${subRoute}`}>
                    {title}
                  </StyledLink>
                </Layout.Card.Text>
                <Layout.Card.Text mobile size={theme.fontSizes.regular} boldest>
                  <StyledLink href={`${ROUTES.blog}${subRoute}`}>
                    {title}
                  </StyledLink>
                </Layout.Card.Text>
                <Layout.Card.Text
                  desktop
                  size={theme.fontSizes.regular}
                  noBottomSpace
                >
                  {description}
                </Layout.Card.Text>
                <Layout.Card.Text
                  mobile
                  size={theme.fontSizes.small}
                  noBottomSpace
                >
                  {description}
                </Layout.Card.Text>
              </StyledArticleContainer>
            );
          })}
        </StyledContentBody>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default BlogFooterSection;
